const CONTACT_PATH = /^\/(en\/)?contact\/?$/

export const getNavigationScrollPosition = ({ pathname = '', hash = '' }) => {
  if (CONTACT_PATH.test(pathname)) {
    return [0, 0]
  }

  return hash ? true : false
}
